/**
 * https://wavesaudio.atlassian.net/browse/DSWEB-2818
 *
 * On 2-9-23 input param planExchRelatedOrderID added
 * When SBSStatusID= 13, text should be "Pending Downgrade from <PlanExchRelatedOrderID>" ("Pending Downgrade" is sbsSerialStatus)
 * When SBSStatusID= 12, text should be "Downgraded to <PlanExchRelatedOrderID>" ("Downgraded" is sbsSerialStatus)
 * When SBSStatusID= 13 or 12 and PlanExchRelatedOrderID is NULL, show only sbsSerialStatus.
 */
export const getSubscriptionStatusText = (
    sbsStatusID: number,
    sbsSerialStatus: string,
    planExchRelatedOrderID: number,
    sbsPlanID: string,
    planExchRelatedSBSPlanID: number
) : string => {
    if(sbsStatusID === 2) return '';

    if((sbsStatusID >= 3 && sbsStatusID <= 11) || (sbsStatusID >= 14 && sbsStatusID <= 17)) return 'Canceled';

    if((sbsStatusID === 12 || sbsStatusID === 13) && (planExchRelatedOrderID === 0 || planExchRelatedOrderID === null)){
        return sbsSerialStatus;
    }

    const plan = !!planExchRelatedSBSPlanID && planExchRelatedSBSPlanID > 0 ? planExchRelatedSBSPlanID : sbsPlanID;

    if(sbsStatusID === 12) {
        return `${ sbsSerialStatus } to #${ plan }-${ planExchRelatedOrderID }`;
    }

    if(sbsStatusID === 13) {
        return `${ sbsSerialStatus } from #${ plan }-${ planExchRelatedOrderID }`;
    }

    return '';
};

export const getPeriodText = (period: string, duration: number) => {
    if(!period) return '';

    period = period.toLowerCase().trim();

    switch(period) {
        case 'annual': {
            return duration === 1 ? 'year' : 'years';
        }
        case 'monthly': {
            return duration === 1 ? 'month' : 'months';
        }
        case 'weekly': {
            return duration === 1 ? 'week' : 'weeks';
        }
        case 'daily': {
            return duration === 1 ? 'day' : 'days';
        }
    }

    return '';
};